import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";

export const FilterDropdown = ({
  isPhaseChecked,
  isTreatmentChecked,
  isCitationChecked,
  isExerciseChecked,
  isLifeStyleChecked,
  isEstimationChecked,
  onPhaseChange,
  onTreatmentChange,
  onCitationChange,
  onExerciseChange,
  onLifeStyleChange,
  onEstimationChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ ml: "auto" }}>
      <Button
        variant="contained"
        startIcon={<FilterListIcon />}
        onClick={handleClick}
        sx={{
          fontSize: "16px",
          fontWeight: 500,
          textTransform: "none",
          borderRadius: "5px",
        }}
      >
        Filter
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{ mt: 1 }}
      >
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox checked={!!isPhaseChecked} onChange={onPhaseChange} />
            }
            label={"Phases of Care"} // Format filter name
          />
        </MenuItem>
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isTreatmentChecked}
                onChange={onTreatmentChange}
              />
            }
            label={"Treatments"} // Format filter name
          />
        </MenuItem>
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isCitationChecked}
                onChange={onCitationChange}
              />
            }
            label={"Citations"} // Format filter name
          />
        </MenuItem>
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isExerciseChecked}
                onChange={onExerciseChange}
              />
            }
            label={"Exercises"} // Format filter name
          />
        </MenuItem>
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isLifeStyleChecked}
                onChange={onLifeStyleChange}
              />
            }
            label={"Lifestyle Tips"} // Format filter name
          />
        </MenuItem>
        <MenuItem disableRipple>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!isEstimationChecked}
                onChange={onEstimationChange}
              />
            }
            label={"Good Faith Estimation"} // Format filter name
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};
